
  <button *ngIf="showToolbar" type="button" class="mat-icon-toggle-button" matIconButton matTooltip="Download image" (click)="handleOpenDialog()" matTooltipPosition="right">
    <mat-icon>get_app</mat-icon>
  </button>
